module.exports = __webpack_public_path__ + "img/logo-pneudart-blue.b5018b28.svg";